"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const actions_1 = require("../../../actions");
const reducers_1 = require("../../../reducers");
const actions_2 = require("../../../actions");
const src_1 = require("@rover/ts-bootstrap/dist/src");
class OverviewModalHeader extends React.Component {
    constructor(props) {
        super(props);
        const { campaignName } = this.props;
        this.state = {
            showPopover: false,
            rename: false,
            name: campaignName,
            willDuplicate: false,
        };
        this.getCampaignType = this.getCampaignType.bind(this);
        this.getTextStyle = this.getTextStyle.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleDuplicate = this.handleDuplicate.bind(this);
        this.handleRename = this.handleRename.bind(this);
        this.handleShowMore = this.handleShowMore.bind(this);
        this.handleArchive = this.handleArchive.bind(this);
        this.showArchiveModal = this.showArchiveModal.bind(this);
    }
    componentWillUnmount() {
        if (!this.state.willDuplicate) {
            this.props.unsetEditableCampaign();
        }
    }
    handleShowMore() {
        this.setState({
            showPopover: !this.state.showPopover,
        });
    }
    getCampaignType(triggerType) {
        switch (triggerType) {
            case 'CampaignScheduledTrigger': {
                return 'Scheduled Notification Campaign';
            }
            case 'CampaignAutomatedTrigger': {
                return 'Automated Notification Campaign';
            }
            case 'CampaignAPITrigger': {
                return 'API Notification Campaign';
            }
            default: {
                return 'Campaign';
            }
        }
    }
    handleDuplicate() {
        const { campaignId, duplicateCampaign, getDuplicateCampaignName } = this.props;
        const newCampaignName = getDuplicateCampaignName();
        this.setState({
            showPopover: false,
            willDuplicate: true,
        }, () => {
            duplicateCampaign(newCampaignName, parseInt(campaignId, 10));
            setTimeout(() => this.setState({ name: newCampaignName }), 250);
        });
    }
    handleRename(name) {
        const { campaignId, renameCampaign } = this.props;
        renameCampaign(name, parseInt(campaignId, 10));
        this.setState({ rename: false, name });
    }
    handleClose() {
        const { location, history, campaignId } = this.props;
        const campaignIdRegEx = new RegExp(`[\\&-]?campaignId=${campaignId}`);
        const search = location.search.replace(campaignIdRegEx, '');
        this.props.handleCloseOverviewModalDisplay(history, `/campaigns/${search}`);
    }
    handleArchive() {
        const { archiveCampaign, campaignId, archiveModalToggle } = this.props;
        this.setState({
            showPopover: false,
        }, () => {
            archiveCampaign(parseInt(campaignId, 10));
            archiveModalToggle(false);
        });
    }
    showArchiveModal() {
        const { archiveModalToggle } = this.props;
        archiveModalToggle(true);
    }
    getTextStyle() {
        const { rename } = this.state;
        let textStyle = {
            color: src_1.white,
            display: 'block',
        };
        if (!rename) {
            textStyle = Object.assign(Object.assign({}, textStyle), { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' });
        }
        return textStyle;
    }
    render() {
        const { archiveCampaign, campaignId, device, isCampaignFinished, location, style, triggerType, isArchiveModalOpen, archiveModalToggle, } = this.props;
        const { name, rename, showPopover } = this.state;
        const popoverProps = {
            placement: 'bottom-end',
        };
        const popoverElementStyle = {
            height: device === 'Mobile' ? 72 : 55,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
        };
        return (React.createElement("div", { style: Object.assign({ height: 152, width: '100%', background: src_1.aquamarine, flex: 'none' }, style) },
            React.createElement("div", { style: {
                    margin: device !== 'Mobile' ? '16px 32px 32px 32px' : '16px 24px 32px 24px',
                } },
                React.createElement("div", { style: {
                        display: 'flex',
                        justifyContent: 'space-between',
                    } },
                    React.createElement("div", { onClick: this.handleClose },
                        React.createElement(src_1.CloseIcon, { fill: src_1.white })),
                    React.createElement(src_1.PopoverContainer, { id: "moreIcon", popoverProps: popoverProps, targetParent: "root", onClick: this.handleShowMore, showPopover: showPopover }, [
                        React.createElement(src_1.MoreIcon, { fill: src_1.white, key: "moreIcon1" }),
                        React.createElement("div", { style: {
                                width: 320,
                            }, key: "moreIcon2" },
                            React.createElement(src_1.SelectableList, { device: device },
                                React.createElement("div", { key: "rename", onClick: () => this.setState({
                                        rename: true,
                                        showPopover: false,
                                    }), style: popoverElementStyle },
                                    React.createElement(src_1.RenameIcon, { fill: src_1.steel, style: { marginRight: 8 } }),
                                    React.createElement(src_1.Text, { text: "Rename", size: "medium" })),
                                React.createElement("div", { key: "duplicate", onClick: this.handleDuplicate, style: popoverElementStyle },
                                    React.createElement(src_1.DuplicateIcon, { fill: src_1.steel, style: { marginRight: 8 } }),
                                    React.createElement(src_1.Text, { text: "Duplicate", size: "medium" })),
                                React.createElement("div", { key: "archive", onClick: this.showArchiveModal, style: popoverElementStyle },
                                    React.createElement(src_1.ArchiveIcon, { fill: src_1.steel, style: { marginRight: 8 } }),
                                    React.createElement(src_1.Text, { text: "Archive", size: "medium" })),
                                location.pathname.includes('report') && (React.createElement("div", { key: "settings", onClick: () => window.location.replace(`/campaigns/settings/?campaignId=${campaignId}`), style: popoverElementStyle },
                                    React.createElement(src_1.GearIcon, { fill: src_1.steel, style: {
                                            marginRight: 8,
                                        } }),
                                    React.createElement(src_1.Text, { text: "Settings", size: "medium" }))),
                                location.pathname.includes('settings') && (React.createElement("div", { key: "report", onClick: () => window.location.replace(`/campaigns/report/?campaignId=${campaignId}`), style: popoverElementStyle },
                                    React.createElement(src_1.BarChartIcon, { fill: src_1.steel, style: {
                                            marginRight: 8,
                                        } }),
                                    React.createElement(src_1.Text, { text: "Report", size: "medium" })))),
                            isArchiveModalOpen && (React.createElement(src_1.Dialog, { buttonPrimaryText: "Cancel", buttonSecondaryText: "Yes", primaryOnClick: () => archiveModalToggle(false), secondaryOnClick: this.handleArchive, isOpen: isArchiveModalOpen, targetParent: "root", dialogText: `Are you sure you'd like to archive this campaign?`, overlayStyle: { zIndex: 1000 } }))),
                    ])),
                React.createElement("div", { style: {
                        marginTop: 16,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }, onClick: () => this.setState({ rename: true }) },
                    React.createElement(src_1.Text, { text: name, size: "h1", textStyle: this.getTextStyle(), contentEditable: rename, handleChange: this.handleRename, handleBlurChange: this.handleRename, onBlurChange: true, id: "renameCampaign" })),
                React.createElement("div", null,
                    React.createElement(src_1.Text, { text: this.getCampaignType(triggerType), size: "medium", textStyle: { color: src_1.white } })))));
    }
}
const mapDispatchToProps = (dispatch, props) => {
    const { location, history } = props;
    return {
        renameCampaign: (name, campaignId) => {
            dispatch(actions_1.renameCampaign(name, campaignId));
        },
        duplicateCampaign: (name, campaignId) => {
            dispatch(actions_1.duplicateCampaign(name, campaignId)).then((id) => {
                let params = location.search.replace(`campaignId=${campaignId}`, `campaignId=${id}`);
                dispatch(actions_1.createEditableCampaign(`${id}`));
                history.push(`/campaigns/wizard/${params}`);
            });
        },
        archiveCampaign: (campaignId) => {
            dispatch(actions_1.archiveCampaign(campaignId)).then((complete) => {
                if (complete) {
                    const campaignIdRegEx = new RegExp(`[\\&-]?campaignId=${campaignId}`);
                    const search = location.search.replace(campaignIdRegEx, '');
                    history.push(`/campaigns/${search}`);
                }
            });
        },
        handleCloseOverviewModalDisplay: (_, path) => {
            dispatch(actions_2.handleCloseOverviewModalDisplay(history, path));
        },
        unsetEditableCampaign: () => {
            dispatch(actions_1.unsetEditableCampaign());
        },
        archiveModalToggle: (display) => {
            dispatch(actions_1.archiveModalOpen(display));
        },
    };
};
const mapStateToProps = (state, ownProps) => {
    const campaign = reducers_1.getCampaign(state, ownProps.campaignId);
    return {
        campaignName: campaign.name,
        triggerType: campaign.trigger.__typename,
        getDuplicateCampaignName: () => reducers_1.getDuplicateCampaignName(campaign),
        isCampaignFinished: reducers_1.getIsCampaignFinished(state, ownProps.campaignId),
        isArchiveModalOpen: reducers_1.getIsArchiveModalOpen(state),
    };
};
exports.default = react_router_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps)(OverviewModalHeader));
